export default class Paths {
  /**
   * Public paths
   */
  public static readonly PUBLIC_OFFENSES_SEARCH = '/offenses/search';
  public static readonly PUBLIC_OFFENSES_LIST = '/offenses/:id';
  public static readonly PUBLIC_OFFENSES_DETAIL = '/offenses/:id/detail';

  public static readonly LOGIN = '/';
  public static readonly REGISTRATION = '/registration';
  public static readonly FORGOTTEN_PASSWORD = '/forgotten-password';
  public static readonly CHANGE_PASSWORD = '/change-password';
  public static readonly VERIFICATION = '/verification';
  public static readonly VERIFY = '/verify';
  public static readonly VERIFY_PARENT = '/verify-parent';
  public static readonly APPROVE_MANAGED_CARD = '/approve-managed-card';
  public static readonly REJECT_CARD_MANAGE_REQUEST_PAGE = '/reject-managed-card';
  public static readonly APP = '/app';
  public static readonly USER_ACCOUNT = '/app/user-account';
  public static readonly USER_ACCOUNT_FINISH_ADD_CARD = '/app/user-account-finish-add-card';
  public static readonly USER_ACCOUNT_FINISH_REGISTER_PORTABLE_CARD = '/app/user-account-finish-register-portable-card';

  /**
   * OAuth login routes
   */
  public static readonly OAUTH = '/oauth';
  public static readonly REGISTER = 'register/:email';
  public static readonly LINK_ACCOUNT = 'link-account/:email';
  public static readonly OAUTH_REGISTRATION = `${Paths.OAUTH}/${Paths.REGISTER}`;
  public static readonly OAUTH_LINK_ACCOUNT = `${Paths.OAUTH}/${Paths.LINK_ACCOUNT}`;

  /**
   * This does not have a left-menu item - it opens only from table in AssignedCardListPage.vue
   */
  public static readonly USER_LINKED_ACCOUNT = '/app/user-linked-account';
  public static readonly USER_LINKED_ACCOUNT_WITH_ID = '/app/user-linked-account/:customerId';
  public static readonly USER_LINKED_ACCOUNT_FINISH_ADD_CARD = '/app/user-linked-account-finish-add-card';
  public static readonly NOTIFICATION_SETTING = '/app/notification-setting';
  public static readonly TICKET_FARE = '/app/ticket-fare';
  public static readonly ELECTRONIC_WALLET = '/app/electronic-wallet';
  public static readonly SHOPPING_CART = '/app/shopping-cart';
  public static readonly ORDER_LIST = '/app/order-list';
  public static readonly ACCOUNT_SETTING = '/app/account-setting';
  public static readonly ASSIGNED_CARD_LIST = '/app/assigned-card-list';
  public static readonly MANAGED_CARD_LIST = '/app/managed-card-list';
  public static readonly CARD_MANAGING_ACCOUNT_LIST = '/app/card-managing-account-list';

  /**
   * Admin paths
   */
  public static readonly ENVIRONMENT_VARIABLES = '/app/admin/environment-variables';
}

/**
 * To go to these paths, user must be logged in. Path.APP includes all the children automatically.
 */
export const LOGIN_REQUIRED_PATHS = [Paths.APP, Paths.APPROVE_MANAGED_CARD, Paths.REJECT_CARD_MANAGE_REQUEST_PAGE];
